var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgV1DesktopChromeNav = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "v1_desktop_chrome_nav_svg__a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#v1_desktop_chrome_nav_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#45464F",
  d: "M8 21v-2H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 17V5q0-.824.587-1.412A1.93 1.93 0 0 1 4 3h8v2H4v12h16v-3h2v3q0 .824-.587 1.413A1.93 1.93 0 0 1 20 19h-4v2zm9-7-5-5 1.4-1.4 2.6 2.575V3h2v7.175L20.6 7.6 22 9z"
}))));
export { SvgV1DesktopChromeNav as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzU4NzlfODEzNzIiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfNTg3OV84MTM3MikiPgo8cGF0aCBkPSJNOCAyMVYxOUg0QzMuNDUgMTkgMi45NzkxNyAxOC44MDQyIDIuNTg3NSAxOC40MTI1QzIuMTk1ODMgMTguMDIwOCAyIDE3LjU1IDIgMTdWNUMyIDQuNDUgMi4xOTU4MyAzLjk3OTE3IDIuNTg3NSAzLjU4NzVDMi45NzkxNyAzLjE5NTgzIDMuNDUgMyA0IDNIMTJWNUg0VjE3SDIwVjE0SDIyVjE3QzIyIDE3LjU1IDIxLjgwNDIgMTguMDIwOCAyMS40MTI1IDE4LjQxMjVDMjEuMDIwOCAxOC44MDQyIDIwLjU1IDE5IDIwIDE5SDE2VjIxSDhaTTE3IDE0TDEyIDlMMTMuNCA3LjZMMTYgMTAuMTc1VjNIMThWMTAuMTc1TDIwLjYgNy42TDIyIDlMMTcgMTRaIiBmaWxsPSIjNDU0NjRGIi8+CjwvZz4KPC9zdmc+Cg==";